/**
 * Image Optimization Utility
 * Generates optimized image URLs with proper sizing, compression, and formats
 */

// Function to get optimized image URL from local paths
export const getOptimizedImageUrl = (imagePath, width = 800, quality = 80) => {
  if (!imagePath) return null;
  
  // If it's already a full URL, return as is
  if (imagePath.startsWith('http')) {
    return imagePath;
  }

  // For local images, we'll use native support with srcset
  return imagePath;
};

// Generate srcset for responsive images
export const generateSrcSet = (imagePath) => {
  if (!imagePath || imagePath.startsWith('http')) {
    return imagePath;
  }

  // Return the image path - browser will handle it
  return imagePath;
};

// Get blur-up placeholder (low quality version)
export const getBlurPlaceholder = (imagePath) => {
  if (!imagePath || imagePath.startsWith('http')) {
    return 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 300"%3E%3Crect fill="%23e0e0e0" width="400" height="300"/%3E%3C/svg%3E';
  }

  // Return the same image - CSS blur will be applied
  return imagePath;
};

// Estimate image dimensions for aspect ratio
export const getImageAspectRatio = (width = 4, height = 3) => {
  return (height / width) * 100;
};

// Format for web optimization
export const imageLoaderConfig = {
  sizes: '(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw',
  formats: ['image/webp', 'image/jpeg'],
  quality: {
    low: 40,
    medium: 60,
    high: 80,
    original: 100
  },
  breakpoints: {
    mobile: 640,
    tablet: 1024,
    desktop: 1920
  }
};
